import { useEffect } from "react";
import dayjs from "dayjs";

import Categories from "@components/layouts/b2c/profile/personalProfile/Categories";
import Continuity from "@components/layouts/b2c/profile/personalProfile/Continuity";
import InfoCard from "@components/layouts/b2c/profile/personalProfile/InfoCard";
import {
  getProfile,
  getProfileStreakStats,
  getStreakDays,
  getTopConsumedCategories,
  getUser,
  useAppSelector,
  useGetUser,
  useProfileStreakStats,
  useStreakDays,
  useTopConsumedCategories,
} from "@lib/stores";
import { useB2B } from "@modules/content/B2BContext";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";

export const Profile = () => {
  const navigate = useAppNavigate();

  const user = useAppSelector(({ auth }) => auth.user);

  const { b2B } = useB2B();

  const { data: userData } = useGetUser();
  const { data: topConsumedCategories } = useTopConsumedCategories();
  const { data: profileStreakStats } = useProfileStreakStats();
  const { data: streakDays } = useStreakDays();

  useEffect(() => {
    getProfile();
    getUser();
    getProfileStreakStats();
    getStreakDays({
      fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
      toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
    });
    getTopConsumedCategories();
  }, []);

  useEffect(() => {
    if (b2B?.isB2B) {
      navigate("/");
    }
  }, [b2B?.isB2B, navigate]);

  return (
    <div className="mx-auto flex w-full max-w-[950px] flex-col items-center justify-center gap-5 py-8">
      <InfoCard
        avatar={
          (user.name || user.email || user.phoneNumber)
            ?.charAt(0)
            .toUpperCase() || "A"
        }
        fullName={user.name || user.email || user.phoneNumber || ""}
        email={user.email || user.phoneNumber || ""}
        booksCount={userData?.completedTitles || 0}
        listeningDuration={Math.floor(
          (userData?.listiningDurationMS || 0) / (1000 * 60 * 60)
        )}
        continuity={profileStreakStats?.currentStreakCount || 0}
      />
      <Continuity
        stats={{
          prevStreak: profileStreakStats?.lastStreakCount || 0,
          currentStreak: profileStreakStats?.currentStreakCount || 0,
          bestStreak: profileStreakStats?.bestStreakCount || 0,
        }}
        streakDays={streakDays.map((s) => dayjs(s.date || "").toDate())}
        onStreakDateChange={(fromDate, toDate) => {
          getStreakDays({
            fromDate,
            toDate,
          });
        }}
      />
      <Categories data={topConsumedCategories} />
    </div>
  );
};
